export default __webpack_public_path__ + "static/1-cyberpunk-fdfe3ddf5d69ee321659d581e5dee54e.png";